import Comments from "../../../Components/Website/Landing/Comments";
import Hero from "../../../Components/Website/Landing/Hero";
import ImageSection from "../../../Components/Website/Landing/ImageSection";
import Services from "../../../Components/Website/Landing/Services";
import PublicLayout from "../../../layouts/PublicLayout";

const Landing = () => {

  return (
    <PublicLayout>
      <Hero />
      <Services/>
      <ImageSection />
      <Comments />
    </PublicLayout>
  );
};

export default Landing;
